import { createApp } from 'vue'
import { i18n } from './i18n'

import { DialogMessageType } from './common/classes'
import useDialogStore from './composables/dialog'
import router from './routes'

import '@fontsource-variable/inter'
import './assets/css/main.css'
import App from '@/App.vue'

const dialog = useDialogStore()

const app = createApp(App).use(router).use(i18n)
app.mount('#app')

app.config.warnHandler = (err) => {
  console.warn(err)
}

if (process.env.NODE_ENV !== 'development') {
  app.config.errorHandler = (err, vm, info) => {
    const error = err as Error
    const message = `${error.message}`
    dialog.actions.pushMessage('Application Error', DialogMessageType.Error, message, 8000)
  }
}
